import React from "react";
import styled from "styled-components";
import { InputWayTextCharElement } from "common/topic/input_way_text";
import { CharacterResult } from "common/character/dto/CharacterResult";
import InputWayTextPlayCharacter from "./InputWayTextPlayCharacter";

export type InputWayTextPlayElementProps = {
  textCharElement: InputWayTextCharElement;
};

const InputWayTextPlayElement = ({
  textCharElement,
}: InputWayTextPlayElementProps) => {
  return (
    <>
      <InputWayTextPlayCharacter
        character={textCharElement.value as CharacterResult}
      />
      <div>
        {!textCharElement.isCharacter && (textCharElement.value as string)}
      </div>
    </>
  );
};

export default InputWayTextPlayElement;
